import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IModalProps, Modal, ModalHeader, ModalBody, ModalFooter, Button } from '@msdyn365-commerce-modules/utilities';
import MsDyn365 from '@msdyn365-commerce/core';
import { shareOrderListAsync } from '../../../../custom-actions/DataActionExtension.g';

interface IOrderListShare {
    ctx: Msdyn365.IActionContext;
    orderListId: string;
    isShareInitiated: boolean;
    setIsShareInitiated: (val: boolean) => void;
    resources: {
        enterEmailAddress: string;
        shareModalHeading: string;
        sharelistButtonText: string;
    };
}

const OrderListShareModal = (props: IOrderListShare) => {
    const { ctx, orderListId, isShareInitiated, setIsShareInitiated, resources } = props;

    const [email, setEmail] = React.useState<string>('');
    const [changeEmailError, setChangeEmailError] = React.useState<string>('');
    const [success, setSuccess] = React.useState<boolean>(true);

    React.useEffect(() => {
        setEmail('');
        setSuccess(false);
    }, [isShareInitiated]);

    React.useEffect(() => {
        if (success) {
            setTimeout(() => {
                setIsShareInitiated(false);
                setSuccess(false);
            }, 2000);
        }
    }, [success]);

    const shareOrderlist = async (email: string) => {
        if (orderListId) {
            console.log(email);
            const res = await shareOrderListAsync({ callerContext: ctx }, orderListId, email);
            if (res.StatusCode === '2000') {
                setSuccess(true);
            } else {
                setChangeEmailError(res?.Description ?? 'Some error occured');
            }
        }
    };

    const modalPropsTerms: IModalProps = {
        applicationNode: MsDyn365.isBrowser ? document.body : '',
        isOpen: isShareInitiated,
        autoFocus: true,
        size: 'sm',
        keyboard: true,
        backdrop: true,
        zIndex: 1000,
        fade: true,
        className: 'share-orderlist-modal',
        toggle: () => setIsShareInitiated(false)
    };

    const isValidEmail = (): boolean => {
        if (!email) return false; // empty string
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let x = emailRegex.test(email);
        return x;
    };
    return (
        <Modal {...modalPropsTerms}>
            <ModalHeader closeAriaLabel='Close' closeButtonLabel='Close' toggle={() => setIsShareInitiated(false)}>
                {resources.shareModalHeading}
            </ModalHeader>

            <ModalBody>
                <>
                    {success ? (
                        <div>
                            {' '}
                            The List has been shared with <strong>{email}</strong>
                        </div>
                    ) : (
                        <div>
                            <div className='input-wrapper'>
                                <div className='label'>{resources.enterEmailAddress}</div>
                                <input
                                    id={'email'}
                                    name={'email'}
                                    type={'email'}
                                    value={email}
                                    className={`user-profile-input`}
                                    aria-required={true}
                                    onChange={e => {
                                        setEmail(e.target.value);
                                        setChangeEmailError('');
                                    }}
                                    disabled={false}
                                />
                            </div>

                            {changeEmailError ? (
                                <div className='email-error'>
                                    <span>{changeEmailError}</span>
                                </div>
                            ) : null}
                        </div>
                    )}
                </>
            </ModalBody>
            <ModalFooter style={{ justifyContent: 'flex-end' }}>
                {!success ? (
                    <Button
                        id={'share order list'}
                        className={`button ${!isValidEmail() ? 'disabled' : ''}`}
                        aria-label={'share order list'}
                        disabled={!isValidEmail()}
                        onClick={() => shareOrderlist(email)}
                        role='button'
                        aria-disabled={!isValidEmail()}
                    >
                        {resources.sharelistButtonText}
                    </Button>
                ) : null}
            </ModalFooter>
        </Modal>
    );
};

export default OrderListShareModal;
